import { render, staticRenderFns } from "./ReceiptForm.vue?vue&type=template&id=71c28050&"
import script from "./ReceiptForm.vue?vue&type=script&lang=js&"
export * from "./ReceiptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports